<template>
  <b-modal
    id="modal-works"
    :title="editData && editData.id ? $t('edit_job_type') :$t('add_job_type')"
    cancel-variant="outline-secondary"
    :ok-title="editData && editData.id ? $t('edit') : $t('general.add')"
    ok-variant="success"
    :cancel-title="$t('general.close')"
    centered
    no-close-on-backdrop
    @show="showModal"
    @ok.prevent="onSubmit"
  >
    <b-form>
      <validation-observer ref="addWorksValidations">

        <b-tabs content-class="pt-1" fill>
          <b-tab active :title="$t('reference.name') + ' uz'">
            <b-form-group :label="$t('reference.name')">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.name')"
                rules="required"
              >
                <b-form-input v-model="title.uz" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('reference.name') + ' ru'">
            <b-form-group :label="$t('reference.name')">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.name')"
                rules="required"
              >
                <b-form-input v-model="title.ru" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-tab>
        </b-tabs>

      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BFormCheckbox,
  BTabs,
  BTab,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { required } from "@core/utils/validations/validations";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    vSelect,
    BTabs,
    BTab,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    editData: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  data() {
    return {


      // ===============  PRIMARY_DATA_SECTION START ===============
      required,
      title: {ru: '', uz: ''},
      params: {
        search: null,
        page_size: 5,
        page: 1,
        pagination: 'number'
      },
      // ===============  PRIMARY_DATA_SECTION END ===============


    };
  },
  computed: {
    // ...mapGetters("obectsWarehouse", ["GET_OBECTS"]),
  },
  async mounted(){

  },
  methods: {
    ...mapActions("brigadeWorks", [
      "CREATE_BRIGADE_WORK_CATEGORIES",
      "UPDATE_PUT_BRIGADE_WORK_CATEGORIES",
    ]),





    // ===============  ON_SHOW_SECTION START ===============
    showModal() {
      this.title = {ru: '', uz: ''}
      if (!this.editData) {
        return;
      }
      if (typeof this.editData === "object" &&this.editData !== null) {
        this.title = this.editData.title;
      }
    },
    // ===============  ON_SHOW_SECTION END ===============








    // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmit() {
      const success = await this.$refs.addWorksValidations.validate();
      if (!success){
        this.$_errToast({message: this.$t('all_fields_are_required')});
        return;
      }

      const req = {
        id: this.editData && this.editData.id ? this.editData.id : null,
        data: this.title,
      };
      

      (this.editData && this.editData.id
        ? this.UPDATE_PUT_BRIGADE_WORK_CATEGORIES({ id: req.id, title: req.data })
        : this.CREATE_BRIGADE_WORK_CATEGORIES({title: req.data})
      )
        .then(() => {
          this.$emit("save");
          this.$_okToast().then(() => {
            this.title = {ru: '', uz: ''},
            this.$bvModal.hide("modal-works");
          });
        })
        .catch((err) => {
          console.log(err.response)
          if(err && err.response && err.response.status && err.response.status == 400 && err.response.data[0]){
            this.$_errToast({message: err.response.data[0]})
          }
        });
    },
    // ===============  ON_SUBMIT_SECTION END ===============




  },
};
</script>

<style scoped>


</style>
